import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/geofences/new')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geofences/new',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
